import React, { useState, useEffect } from 'react'
import Breadcrumb from '../Components/Breadcrumb'
import Pagehelmet from '../Components/Pagehelmet'
import { Link } from 'react-router-dom'
import axios from 'axios';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    TablePagination,
    Avatar,
    Chip,
    Card,
    CardContent,
    CardMedia,
    Grid
} from '@mui/material';
import { format } from 'date-fns';
const Eventlists = () => {

    const [data, setData] = useState([]);
    console.log(data, 'data')
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(false);

    const url = `${process.env.REACT_APP_API_URL}/events/view-published-events`;
    const headers = {
        Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
    };

    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await axios.post(url, {}, { headers });
            const sortedData = response?.data?.sort(
                (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
            ) || [];
            setData(sortedData);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'published': return 'success';
            case 'draft': return 'warning';
            case 'cancelled': return 'error';
            case 'sold-out': return 'secondary';
            default: return 'default';
        }
    };

    const formatDate = (dateString) => {
        return format(new Date(dateString), 'PPpp');
    };
  if (loading) {
    return (
      <div className="container text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }


    return (
        !loading &&
        <div>
            <Pagehelmet pageTitle="Event Lists" />


          
            <Breadcrumb title="21 St Annual Summer Camp Event" />
          

            {/*--Schedules Section start--*/}
            <section className="schedules pb-0">
                <div className="container">
                    <div className="schedule-inner">
                        <div className="schedule-list-outer text-center">
                            <div className="row align-items-center">
                                <div className="col-lg-12">
                                    <div className="schedule-list text-center text-sm-start m-sm-0">
                                        <div className="row gx-md-5">
                                            {data?.map(event => (
                                                <Link 
                                                
                                                 to={`/Tickettypes/${event.id}`}

                                                   state={{
                                                            event: event,           // your event object or ID
                                                      // your ticket type ID or object
                                                        }}
                                                
                                                
                                                className="col-lg-6 col-md-6" key={event._id}>
                                                    <div className="schedule-list-left">
                                                        <div className="schedule-list-box bg-white border-lightgrey border border-2 rounded px-6 py-4 mb-4">
                                                            {/* Event Image */}
                                                            {event.imageUrl && (
                                                                <div className="schedule-box-image mb-3">
                                                                    <img

                                                                        src={`${process.env.REACT_APP_API_URL}/images/${event.imageUrl}` || '/placeholder-event.jpg'}
                                                                        alt={event.name}
                                                                        className="img-fluid rounded"
                                                                        style={{ minHeight: '240px', width: '100%', objectFit: 'cover' }}
                                                                    />
                                                                </div>
                                                            )}

                                                            {/* Event Title */}
                                                            <div className="schedule-box-title">
                                                                <h5 className="mb-2">
                                                                    <Link to={`/Eventdetail/${event._id}`} className="black">
                                                                        {event.name}
                                                                    </Link>
                                                                </h5>
                                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                                    <span className="badge bg-primary me-2">
                                                                        {event.category}
                                                                    </span>
                                                                    {event.subcategory && event.subcategory !== 'Other' && (
                                                                        <span className="badge bg-secondary">
                                                                            {event.subcategory}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            {/* Event Info */}
                                                            <div className="schedule-box-info">
                                                                <p  className="black mb-2">{event.description}</p>

                                                                <ul className="black mb-2 p-0">
                                                                    <li className="d-inline">
                                                                        <i className="fa fa-clock-o pink me-2" aria-hidden="true"></i>
                                                                        <small>
                                                                            {new Date(event.startDate).toLocaleDateString('en-US', {
                                                                                year: 'numeric',
                                                                                month: 'long',
                                                                                day: 'numeric',
                                                                            })}
                                                                            {event.endDate && (
                                                                                <> - {new Date(event.endDate).toLocaleDateString('en-US', {
                                                                                    month: 'long',
                                                                                    day: 'numeric',
                                                                                })}</>
                                                                            )}
                                                                        </small>
                                                                    </li>
                                                                    <li className="d-inline">
                                                                        <i className="fa fa-thumb-tack pink mx-2" aria-hidden="true"></i>
                                                                        <small>
                                                                            {event.venue?.name}, {event.venue?.address}
                                                                        </small>
                                                                    </li>
                                                                    <li className="d-block mt-1">
                                                                        <i className="fa fa-ticket pink me-2" aria-hidden="true"></i>
                                                                        <small>
                                                                            {event.availableTickets !== undefined ? (
                                                                                `${event.availableTickets} tickets available`
                                                                            ) : (
                                                                                'Tickets available'
                                                                            )}
                                                                        </small>
                                                                    </li>
                                                                </ul>
                                                            </div>

                                                            {/* Status Badge */}
                                                            <div className="mb-2">
                                                                <span className={`badge ${event.status === 'published' ? 'bg-success' :
                                                                        event.status === 'draft' ? 'bg-secondary' :
                                                                            event.status === 'cancelled' ? 'bg-danger' :
                                                                                'bg-warning' // sold-out
                                                                    }`}>
                                                                    {event.status.toUpperCase()}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Link>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </div>
    )
}

export default Eventlists